import ReactMarkdown from "react-markdown";

/**
 * Renders an AI-generated string as proper markdown using @tailwindcss/typography
 * `prose` styles. Drop-in replacement for the previous whitespace-pre-wrap divs.
 */
export default function MarkdownOutput({ children, mono = false, testid, className = "" }) {
    if (!children) return null;
    return (
        <div
            className={`mt-6 p-4 border border-border rounded-md bg-muted/30 prose prose-sm prose-neutral max-w-none ${mono ? "font-mono prose-pre:font-mono" : ""} prose-headings:font-display prose-headings:tracking-tight prose-p:leading-relaxed prose-li:leading-relaxed prose-strong:text-foreground prose-a:text-gold prose-code:text-gold prose-code:before:content-none prose-code:after:content-none ${className}`}
            data-testid={testid}
        >
            <ReactMarkdown>{children}</ReactMarkdown>
        </div>
    );
}
